import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { IconAddUser } from 'jitsi/base/icons/svg';
import Button from 'jitsi/base/ui/components/web/Button';
import { BUTTON_TYPES } from 'jitsi/base/ui/constants.web';
import { beginAddPeople } from 'jitsi/invite/actions.any';
export const InviteButton = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const handleClick = useCallback(() => {
        dispatch(beginAddPeople());
    }, [dispatch]);
    return (React.createElement(Button, { accessibilityLabel: t('participantsPane.actions.invite'), fullWidth: true, icon: IconAddUser, labelKey: 'participantsPane.actions.invite', onClick: handleClick, type: BUTTON_TYPES.PRIMARY }));
};
